(function() {
  function removeOpenAttributeIfSmallScreen() {
    if (window.innerWidth < 980) { // Replace 768 with your desired breakpoint
      var elements = document.querySelectorAll('.disclosure.disclosure--row[open]');
      for (var i = 0; i < elements.length; i++) {
        elements[i].removeAttribute('open');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', removeOpenAttributeIfSmallScreen);
  window.addEventListener('resize', removeOpenAttributeIfSmallScreen);
})();